import localFont from 'next/font/local'

export const primaryFont = localFont({
  src: [
    {
      path: '../../../../shared/assets/fonts/everett-light.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../../../../shared/assets/fonts/everett-regular.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../../../../shared/assets/fonts/everett-medium.woff2', 
      weight: '500',
      style: 'normal',
    }
  ],
  fallback: ['Times New Roman', 'serif'],
  preload: true,
  display: 'swap',
})

export const getFontClassName = (font: typeof primaryFont) => {
  if (process.env.STORYBOOK) {
    return {}
  }
  return font.style
}
